module.exports = __webpack_public_path__ + "static/media/background-login-1.d730556f.jpeg";